import { render, staticRenderFns } from "./MediaIcon.vue?vue&type=template&id=63962c22&scoped=true&"
import script from "./MediaIcon.vue?vue&type=script&lang=js&"
export * from "./MediaIcon.vue?vue&type=script&lang=js&"
import style0 from "./MediaIcon.vue?vue&type=style&index=0&id=63962c22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63962c22",
  null
  
)

export default component.exports